<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Incident</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">
              {{ "INCIDENT.INCIDENT_MANAGEMENT_OVERVIEW" | translate }}
            </li>
            <li class="filter-sort">
              <div class="filter-sort-wrapper">
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#filter"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-filter"
                    aria-hidden="true"
                    pTooltip="Filter"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li>
                      <div class="leave-type">
                        <h5 class="margin-bottom-10">
                          {{ "INCIDENT.STATUS" | translate }}
                        </h5>
                        <p-multiSelect
                          [options]="statusList"
                          [(ngModel)]="statusId"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INCIDENT.INCIDENT_DATE" | translate }}</h5>
                        <div
                          class="col-lg-12 col-md-11 col-sm-11 no-padding margin-top-10"
                        >
                          <div
                            class="col-lg-6 col-md-6 col-sm-6 no-padding-left"
                          >
                            <p-calendar
                              [showIcon]="true"
                              [maxDate]="currentDate"
                              [showTime]="true"
                              placeholder="From"
                              dateFormat="dd/mm/yy"
                              [(ngModel)]="incidentFromDate"
                              class="custom-datepicker"
                              readonlyInput="true"
                              required
                              #timeOfUse="ngModel"
                              monthNavigator="true"
                              yearNavigator="true"
                              yearRange="1950:2100"
                              showButtonBar="true"
                            ></p-calendar>
                          </div>
                          <div
                            class="col-lg-6 col-md-6 col-sm-6 no-padding-right"
                          >
                            <p-calendar
                              [showIcon]="true"
                              [minDate]="incidentFromDate"
                              [maxDate]="currentDate"
                              dateFormat="dd/mm/yy"
                              [showTime]="true"
                              placeholder="To"
                              [(ngModel)]="incidentToDate"
                              class="custom-datepicker"
                              readonlyInput="true"
                              required
                              #timeOfUse="ngModel"
                              monthNavigator="true"
                              yearNavigator="true"
                              yearRange="1950:2100"
                              showButtonBar="true"
                            >
                            </p-calendar>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </li>
                    <li>
                      <div>
                        <h5 class="margin-bottom-10">
                          {{ "INCIDENT.CASE_OWNER" | translate }}
                        </h5>
                        <label class="margin-bottom-10">
                          <p-autoComplete
                            [(ngModel)]="incidentFilterData.CaseOwner"
                            [suggestions]="userResults"
                            (completeMethod)="getUsersOnSearch($event)"
                            (onSelect)="selectCaseOwner($event)"
                            (change)="selectCaseOwner($event)"
                            placeholder="Incident Owner"
                            field="FullName"
                            [minLength]="1"
                            [style]="{ width: '100%' }"
                            [inputStyle]="{ width: '100%' }"
                            [forceSelection]="true"
                            appendTo="body"
                          >
                            <ng-template let-caseowner pTemplate="item">
                              <span [title]="caseowner.Email">{{
                                caseowner.FullName
                              }}</span>
                            </ng-template>
                          </p-autoComplete>
                        </label>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INCIDENT.LOCATION" | translate }}</h5>
                        <p-multiSelect
                          [options]="locationList"
                          [(ngModel)]="selectedLocations"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INCIDENT.INCIDENT_TYPE" | translate }}</h5>
                        <p-multiSelect
                          [options]="incidentTypeList"
                          [(ngModel)]="selectedincidentTypeId"
                        >
                        </p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INCIDENT.REPORTED_TO" | translate }}</h5>
                        <p-multiSelect
                          [options]="reportedToList"
                          [(ngModel)]="selectedReportedTo"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>Unit</h5>
                        <p-multiSelect
                          [options]="unitList"
                          [(ngModel)]="selectedUnit"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <h5>{{ "INCIDENT.HIGH_POTENTIAL" | translate }}</h5>
                      <p-multiSelect
                        [options]="highPotentials"
                        [(ngModel)]="selectedPotential"
                      ></p-multiSelect>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INCIDENT.INCIDENT_RATINGS" | translate }}</h5>
                        <div
                          class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-top-10"
                        >
                          <div
                            class="col-lg-4 col-md-4 col-sm-6 col-xs-12 no-padding-left"
                          >
                            <label>Potential Assessment</label>
                            <p-dropdown
                              appendTo="body"
                              [style]="{ width: '100%' }"
                              [options]="ratings"
                              [(ngModel)]="incidentRating.PotentialAssessment"
                            ></p-dropdown>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label>Terms of Reference</label>
                            <p-dropdown
                              appendTo="body"
                              [style]="{ width: '100%' }"
                              [options]="ratings"
                              [(ngModel)]="incidentRating.TermsOfReference"
                            ></p-dropdown>
                          </div>
                          <div
                            class="col-lg-4 col-md-4 col-sm-6 col-xs-12 no-padding-right"
                          >
                            <label>Follow-up Execution</label>
                            <p-dropdown
                              appendTo="body"
                              [style]="{ width: '100%' }"
                              [options]="ratings"
                              [(ngModel)]="incidentRating.FollowUpExecution"
                            ></p-dropdown>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                        <div
                          class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"
                        >
                          <div
                            class="col-lg-4 col-md-4 col-sm-6 col-xs-12 no-padding-left"
                          >
                            <label>Investigation Quality</label>
                            <p-dropdown
                              appendTo="body"
                              [style]="{ width: '100%' }"
                              [options]="ratings"
                              [(ngModel)]="incidentRating.InvestigationQuality"
                            ></p-dropdown>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label>Field Review</label>
                            <p-dropdown
                              appendTo="body"
                              [style]="{ width: '100%' }"
                              [options]="ratings"
                              [(ngModel)]="incidentRating.FieldReview"
                            ></p-dropdown>
                          </div>
                          <div
                            class="col-lg-4 col-md-4 col-sm-6 col-xs-12 no-padding-right"
                          >
                            <label>Management Review</label>
                            <p-dropdown
                              appendTo="body"
                              [style]="{ width: '100%' }"
                              [options]="ratings"
                              [(ngModel)]="incidentRating.ManagementReview"
                            ></p-dropdown>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li class="filter-footer">
                      <footer>
                        <a
                          (click)="resetFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-reset"
                        >
                          <i class="fa fa-refresh"></i
                          >{{ "INCIDENT.RESET" | translate }}
                        </a>
                        <a
                          (click)="doneFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-submit"
                        >
                          <i class="fa fa-check"></i
                          >{{ "INCIDENT.DONE" | translate }}
                        </a>
                      </footer>
                    </li>
                  </ul>
                </div>
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#sort"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-sort"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    pTooltip="Sort"
                    tooltipPosition="top"
                    data-original-title="Sort"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideSort">
                  <ul
                    class="filter-section-wrapper sort-section-wrapper collapse"
                    id="sort"
                  >
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ "INCIDENT.ID" | translate }}</label>
                          <a class="">
                            <i
                              (click)="ascIncidentId()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="selected">
                            <i
                              (click)="descIncidentId()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ "INCIDENT.DATE" | translate }}</label>
                          <a class="">
                            <i
                              (click)="ascSubmissionDate()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="selected">
                            <i
                              (click)="descSubmissionDate()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="no-margin-right">
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ "INCIDENT.CASE_OWNER" | translate }}</label>
                          <a class="">
                            <i
                              (click)="ascCaseOwner()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="selected">
                            <i
                              (click)="descCaseOwner()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div
              class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10"
            >
              <a
                [ngClass]="
                  incidentRequestData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="
                  incidentRequestData.length
                    ? exportToExcel()
                    : $event.preventDefault()
                "
                class="btn btn-primary primary-btn button-excel"
                role="button"
              >
                <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To Excel
              </a>
              <a
                [ngClass]="
                  incidentRequestData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="
                  incidentRequestData.length
                    ? downloadZIP()
                    : $event.preventDefault()
                "
                class="btn btn-primary primary-btn button-zip"
                role="button"
              >
                <i class="fa fa-file-zip-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To ZIP
              </a>
            </div>
            <div
              class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right"
            >
              <input
                type="text"
                placeholder="Search"
                class="form-control search-obs"
                [(ngModel)]="searchText"
                (keyup.enter)="searchData()"
              />
              <button class="btn btn-primary primary-btn">
                <i
                  class="fa fa-search search"
                  (click)="searchData()"
                  [class.padding]="searchText.length > 0"
                ></i>
                <i
                  class="fa fa-close clear"
                  *ngIf="searchText.length > 0"
                  (click)="clearSearch()"
                ></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div
            class="table-responsive margin-top-15"
            *ngIf="!showcaseOwner && !isshowBackOffice"
          >
            <table
              align="center"
              class="table table-bordered table-striped table-condensed"
            >
              <thead>
                <tr>
                  <th style="width: 20px">
                    <input
                      type="checkbox"
                      [checked]="isIncidentsChecked"
                      (change)="selectAllIncidents($event.target.checked)"
                      [(ngModel)]="isIncidentsChecked"
                      [value]="isIncidentsChecked"
                    />
                  </th>
                  <th style="width: 80px">{{ "INCIDENT.ID" | translate }}</th>
                  <th style="width: 80px">{{ "INCIDENT.UNIT" | translate }}</th>
                  <th style="width: 50px">
                    {{ "INCIDENT.CLOSED_ACTIONS" | translate }}
                  </th>
                  <th style="width: 125px">
                    {{ "INCIDENT.SHORT_DESCRIPTION" | translate }}
                  </th>
                  <th style="width: 125px">
                    Contract Holder
                  </th>
                  <th style="width: 125px">
                    Contract Number
                  </th>
                  <th style="width: 190px">
                    {{ "INCIDENT.DATE" | translate }}
                  </th>
                  <th style="width: 130px">
                    {{ "INCIDENT.INCIDENT_TYPE" | translate }}
                  </th>
                  <th style="width: 130px">
                    {{ "INCIDENT.CASE_OWNER" | translate }}
                  </th>
                  <th style="width: 140px">
                    {{ "INCIDENT.HIGH_POTENTIAL" | translate }}
                  </th>
                  <th style="width: 125px">
                    {{ "INCIDENT.STATUS" | translate }}
                  </th>
                  <th style="width: 50px">
                    {{ "INCIDENT.DOWNLOAD" | translate }}
                  </th>

                  <th style="width: 50px" *ngIf="incidentPermission.SUPER_Admin" >Action</th>
                    
                </tr>
              </thead>
              <tbody>
                <tr
                  (contextmenu)="
                    cm.show($event); showContextMenu(incidentRequest)
                  "
                  #row
                  style="cursor: pointer"
                  *ngFor="
                    let incidentRequest of incidentRequestData
                      | paginate
                        : {
                            itemsPerPage: itemPerPage,
                            currentPage: pageSize,
                            totalItems: rowCount
                          }
                  "
                  id="{{ incidentRequest.IncidentRequestId }}"
                >
                  <td>
                    <span *ngIf="incidentRequest.Status === 'Draft'">
                      <input
                        type="checkbox"
                        (change)="selectIncidents(incidentRequest, $event)"
                        [value]="incidentRequest"
                        [disabled]="incidentRequest.Status === 'Draft'"
                      />
                    </span>
                    <span *ngIf="incidentRequest.Status !== 'Draft'">
                      <input
                        type="checkbox"
                        [(ngModel)]="incidentRequest.Checked"
                        [checked]="incidentRequest.Checked"
                        (change)="selectIncidents(incidentRequest, $event)"
                        [value]="incidentRequest"
                      />
                    </span>
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    <span
                      *ngIf="incidentRequest.Status === 'Draft'"
                      style="color: red"
                      >Draft</span
                    >
                    <span *ngIf="incidentRequest.Status !== 'Draft'">{{
                      incidentRequest.DisplayId
                    }}</span>
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    {{ incidentRequest.UnitName }}
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    {{ incidentRequest.ClosedActions }}
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    <div
                      class="ellepsis-obs"
                      [popover]="incidentRequest.ShortDescription"
                      popoverTitle="Short Description"
                      popoverPlacement="bottom"
                      [popoverOnHover]="true"
                      [popoverCloseOnClickOutside]="true"
                      [popoverCloseOnMouseOutside]="false"
                      [popoverDisabled]="false"
                      [popoverAnimation]="true"
                      [popoverDismissTimeout]="0"
                    ></div>
                    {{ incidentRequest.ShortDescription }}
                  </td>
                  <td
                  (click)="
                    getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                  "
                >
                  {{ incidentRequest.ContractHolder }}
                </td>
                <td
                (click)="
                  getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                "
              >
                {{ incidentRequest.ContractNumber }}
              </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    {{ incidentRequest.IncidentDate | dateTimeFormat }}
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                  <div
                  class="ellepsis-obs"
                  [popover]="incidentRequest.IncidentTypes"
                  popoverTitle="Incident Type"
                  popoverPlacement="bottom"
                  [popoverOnHover]="true"
                  [popoverCloseOnClickOutside]="true"
                  [popoverCloseOnMouseOutside]="false"
                  [popoverDisabled]="false"
                  [popoverAnimation]="true"
                  [popoverDismissTimeout]="0"
                >
                {{ incidentRequest.IncidentTypes }}
                </div>

                    
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    {{ incidentRequest.CaseOwner.FullName }}
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    {{ incidentRequest.IsHighPotential ? "Yes" : "No" }}
                  </td>
                  <td
                    (click)="
                      getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                    "
                  >
                    {{ incidentRequest.Status }}
                  </td>
                  <td (click)="downloadPDF(incidentRequest.IncidentRequestId)">
                    <i class="fa fa-download"></i>
                  </td>

                  <td *ngIf="incidentPermission.SUPER_Admin">
                    <ara-record-actions *ngIf="incidentRequest.Status === 'Deleted'" [SourceId]="incidentRequest.IncidentRequestId" ModuleName="Incident" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >

                    </ara-record-actions>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style="width: 500px; margin-top: 15px; color: red"
              *ngIf="incidentRequestData.length == 0"
            >
              No Records Found
            </div>
            <div style="width: 500px" *ngIf="incidentRequestData.length > 1">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <div class="card-view">
            <label class="checkbox-inline margin-bottom-10 pull-right">
              <input
                type="checkbox"
                [checked]="isIncidentsChecked"
                (change)="selectAllIncidents($event.target.checked)"
                [(ngModel)]="isIncidentsChecked"
                [value]="isIncidentsChecked"
              />Select All
            </label>
            <div class="clearfix"></div>
            <div
              class="card"
              *ngFor="
                let incidentRequest of incidentRequestData
                  | paginate
                    : {
                        itemsPerPage: itemPerPage,
                        currentPage: pageSize,
                        totalItems: rowCount
                      }
              "
            >
              <div
                [popover]="incidentRequest.ShortDescription"
                popoverTitle="Short Description"
                popoverPlacement="bottom"
                [popoverOnHover]="false"
                [popoverCloseOnClickOutside]="true"
                [popoverCloseOnMouseOutside]="true"
                [popoverDisabled]="false"
                [popoverAnimation]="true"
                [popoverDismissTimeout]="0"
              >
                <h5 class="card-title">
                  <span class="ellepsis-mobile">{{
                    incidentRequest.ShortDescription
                  }}</span>
                  <span>
                    <input
                      type="checkbox"
                      [(ngModel)]="incidentRequest.Checked"
                      [checked]="incidentRequest.Checked"
                      (change)="selectIncidents(incidentRequest, $event)"
                      [value]="incidentRequest"
                    />
                  </span>
                </h5>
              </div>
              <p
                class="card-sub-title"
                (click)="
                  getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                "
              >
                <span>{{ incidentRequest.DisplayId }}</span> -
                <span>{{ incidentRequest.UnitName }}</span>
              </p>
              <p
                (click)="
                  getCurrentDOMElementId(incidentRequest.IncidentRequestId)
                "
              >
                <span>{{ incidentRequest.IncidentDate | dateTimeFormat }}</span>
                - <span>{{ incidentRequest.Status }}</span>
              </p>
            </div>
            <div
              style="margin-top: 15px; color: red"
              *ngIf="incidentRequestData.length == 0"
            >
              {{ noRecordsMsg }}
            </div>
            <div class="col-sm-12 col-xs-12">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<p-contextMenu
  [appendTo]="row"
  [target]="row"
  #cm
  [model]="contextItems"
></p-contextMenu>
